import React from 'react';
import { useTranslation } from 'react-i18next';
import { mapLocaleLang } from 'src/shared/helpers/mapLocaleLang';
import { ConsentTerms } from './ConsentTerms';
import { RegistrationFormTestId } from './RegistrationForm';
import { SingleSignOnFormTestId } from './SingleSignOnForm';

export enum TermsTypeMain {
    TOS = 'TOS',
    PRIVACY_POLICY = 'PRIVACY_POLICY',
    PRIVACY_POLICY_EURO = 'PRIVACY_POLICY_EURO',
    PERSONAL_HEALTH_INFO = 'PERSONAL_HEALTH_INFO',
}

interface Props {
    hideTosPrivacyUpdateMemberWeb?: boolean;
    showEuPersonalHealthInfoTerm?: boolean;
    isEuropeanCountry: boolean;
    onChange: (value: string) => void;
    termsAccepted: boolean;
    privacyAccepted: boolean;
    personalHealthAccepted: boolean;
    isSSO?: boolean;
}

export const ConsentTermsMain: React.FC<Props> = props => {
    const {
        hideTosPrivacyUpdateMemberWeb,
        showEuPersonalHealthInfoTerm,
        isEuropeanCountry,
        onChange,
        termsAccepted,
        privacyAccepted,
        personalHealthAccepted,
        isSSO,
    } = props;
    const { i18n } = useTranslation();
    const { language } = i18n;

    return (
        <>
            <ConsentTerms
                type={TermsTypeMain.TOS}
                firstUrl={`https://www.modernhealth.com/terms-of-use${mapLocaleLang(language)}`}
                dataTestId={
                    isSSO
                        ? SingleSignOnFormTestId.TermsCheckBox
                        : RegistrationFormTestId.TermsCheckBox
                }
                onChange={() => onChange('termsAccepted')}
                isChecked={termsAccepted}
                hideTosPrivacyUpdateMemberWeb={hideTosPrivacyUpdateMemberWeb}
            />
            <ConsentTerms
                type={TermsTypeMain.PRIVACY_POLICY}
                firstUrl={`https://www.modernhealth.com/privacy-notice${mapLocaleLang(language)}`}
                shouldRender={!hideTosPrivacyUpdateMemberWeb && !isEuropeanCountry}
                dataTestId={
                    isSSO
                        ? SingleSignOnFormTestId.PrivacyCheckBox
                        : RegistrationFormTestId.PrivacyCheckBox
                }
                onChange={() => onChange('privacyAccepted')}
                isChecked={privacyAccepted}
            />
            <ConsentTerms
                type={TermsTypeMain.PRIVACY_POLICY_EURO}
                firstUrl={`https://www.modernhealth.com/privacy-notice${mapLocaleLang(language)}`}
                shouldRender={!hideTosPrivacyUpdateMemberWeb && isEuropeanCountry}
                dataTestId={
                    isSSO
                        ? SingleSignOnFormTestId.PrivacyCheckBox
                        : RegistrationFormTestId.PrivacyCheckBox
                }
                onChange={() => onChange('privacyAccepted')}
                isChecked={privacyAccepted}
            />
            {showEuPersonalHealthInfoTerm && (
                <ConsentTerms
                    type={TermsTypeMain.PERSONAL_HEALTH_INFO}
                    shouldRender={!hideTosPrivacyUpdateMemberWeb && isEuropeanCountry}
                    dataTestId={RegistrationFormTestId.PersonalHealthInfoCheckBox}
                    onChange={() => onChange('personalHealthAccepted')}
                    isChecked={personalHealthAccepted}
                />
            )}
        </>
    );
};
